export const badgeGroupSizes = ['sm', 'md', 'lg'] as const
export type BadgeGroupSize = (typeof badgeGroupSizes)[number]

export type BadgeGroupArgs = {
  size?: BadgeGroupSize
}
